import { getStandardReview, getSwrCalendarFilters } from "frontend/communications/standards"
import { getSWAActionsStats } from 'frontend/communications/stats'
import { getSwrOperators } from 'frontend/communications/apiClient'

const stateObj = {
  standardReview: null,
  swrOperators: [],
  swaActionsStats: null,
  swrStats: null,
  swaCalendarFilters: [],
}

const gettersObj = {
  getStandardReview (state) {
    return state.standardReview
  },
  getSwrOperators (state) {
    return state.swrOperators
  },
  getSWAActionsStats (state) {
    return state.swaActionsStats
  },
  getSWACalendarFilters (state) {
    return state.swaCalendarFilters
  },
}

const mutationsObj = {
  setSWACalendarFilters (state, filters) {
    state.swaCalendarFilters = filters
  },
  setSwrOperators (state, operators) {
    state.swrOperators = operators
  },
  setStandardReview (state, standardReview) {
    state.standardReview = standardReview
  },
  setSWAActionsStats (state, stats) {
    state.swaActionsStats = stats
  },
}

const actionsObj = {
  async fetchSwrOperators ({ commit }) {
    const operators = await getSwrOperators(null, false)
    commit('setSwrOperators', operators)
    return operators
  },
  async fetchSwrCalendarFilters ({ commit }) {
    const filters = await getSwrCalendarFilters(null, false)
    commit('setSWACalendarFilters', filters)
    return filters
  },
  async fetchStandardReview ({ commit, getters }, {id, force=false}) {
    const storedStandardReview = getters.getStandardReview
    if (!force && id && storedStandardReview && id === storedStandardReview.id) {
      return storedStandardReview
    }
    const standardReview = await getStandardReview(id)
    commit('setStandardReview', standardReview)
    return standardReview
  },
  async fetchSWAActionsStats ({ commit }, payload) {
    const stats = await getSWAActionsStats(payload)
    commit('setSWAActionsStats', stats)
    return stats
  },
}

export default {
  state: stateObj,
  getters: gettersObj,
  mutations: mutationsObj,
  actions: actionsObj,
}
